import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { EventItemComponent } from "./event-item/event-item.component";
import { EventLineComponent } from "./event-line/event-line.component";
import { IndicatorModule } from "../indicator/indicator.module";

@NgModule({
	imports: [CommonModule, MatTooltipModule, IndicatorModule],
	declarations: [EventLineComponent, EventItemComponent],
	exports: [EventLineComponent, EventItemComponent],
})
export class TimelineModule {}
